<div class="customers">
  <div class="row">
    <div class="filter-container">
      <div class="filter-buttons">
        <button
          *ngFor="let filter of switchFilterStatuses"
          [ngClass]="
            switchFilterStatus === filter.value
              ? filter.styleClass + '--active'
              : filter.styleClass
          "
          (click)="onApplyClick(dt, filter.value)"
          class="status-button"
        >
          {{ getLabel(filter.isInModeration, filter.label) }}
        </button>
      </div>
      <div class="filter-inputs">
        <div class="filters-first-row">
          <div>
            <div class="input-header">
              {{ 'label.CustomerName' | translate }}
            </div>
            <div>
              <input type="text" [(ngModel)]="filterPagingWrapper.name" />
            </div>
          </div>
          <div>
            <div class="input-header">
              {{ 'label.CustomerAgent' | translate }}
            </div>
            <div>
              <input type="text" [(ngModel)]="filterPagingWrapper.agent" />
            </div>
          </div>
          <div>
            <div class="input-header">{{ 'label.TaxId' | translate }}</div>
            <div>
              <input type="text" [(ngModel)]="filterPagingWrapper.taxCode" />
            </div>
          </div>
        </div>
        <div class="filters-second-row">
          <div>
            <div class="input-header">
              {{ 'label.ContactPersonEmail' | translate }}
            </div>
            <div>
              <input
                type="text"
                [(ngModel)]="filterPagingWrapper.contactPersonEmail"
              />
            </div>
          </div>
          <div class="c-date-picker">
            <div class="input-header">
              {{ 'label.RegistrationDate' | translate }}:
            </div>
            <hr-date-range-picker
              class="date-picker"
              [dateFormat]="specialDateFormat"
              [style]="{
                width: '175px',
                height: '38px',
                'min-width': '5em',
                border: '1px solid #ddd'
              }"
              [maxStartDate]="currentDate"
              [maxEndDate]="currentDate"
              [(ngModel)]="filterPagingWrapper.registrationDate"
            ></hr-date-range-picker>
          </div>
          <div class="filter-inputs-container">
            <div class="input-header">{{ 'label.Portfolio' | translate }}</div>
            <div>
              <select [(ngModel)]="filterPagingWrapper.portfolioId">
                <option
                  *ngFor="let item of portfolios"
                  [value]="item.portfolioId"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div class="filters-third-row">
  
        </div> -->
        <div>
          <div class="bottom-buttons">
            <button class="apply" (click)="onApplyClick(dt)">
              {{ 'label.Filter' | translate }}
            </button>
            <button class="clear" (click)="onClearClick()">
              {{ 'label.Clear' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="list-container">
      <p-table
        [value]="customerList"
        #dt
        [rowHover]="false"
        [lazy]="true"
        [paginator]="true"
        [rows]="pageSize"
        showGridlines
        (onLazyLoad)="onLoad($event)"
        [totalRecords]="totalRecords"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [pSortableColumn]="'name'">
              {{ 'label.CustomerName' | translate }}
              <p-sortIcon
                [field]="'name'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th style="width: 10%">
              {{ 'label.Portfolio' | translate }}
            </th>
            <th style="width: 15%">
              {{ 'label.AccountManager' | translate }}
            </th>
            <th style="width: 130px" [pSortableColumn]="'city'">
              {{ 'label.Location' | translate }}
              <p-sortIcon
                [field]="'city'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th
              style="width: 120px; text-align: center"
              [pSortableColumn]="'registrationDate'"
            >
              {{ 'label.RegistrationDate' | translate }}
              <p-sortIcon
                [field]="'registrationDate'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>
            <th style="width: 120px" [pSortableColumn]="'statusName'">
              {{ 'label.Status' | translate }}
              <p-sortIcon
                [field]="'statusName'"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              ></p-sortIcon>
            </th>

            <th style="width: 13%">&nbsp;</th>
            <th style="width: 101px">&nbsp;</th>
            <th style="width: 50px">&nbsp;</th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-customer
          let-expanded="expanded"
          let-columns="columns"
        >
          <tr>
            <td
              [ngStyle]="{
              'border-left': '4px solid ' + getColorByStatus(customer.statusId, isForBorder),
            }"
            >
              <span class="customer-edit-link" title="{{ customer.name }}"
                ><a [routerLink]="['/customers/view', customer?.customerId]">{{
                  customer.name
                }}</a></span
              >
            </td>
            <td>
              <span>{{ customer?.portfolio }}</span>
            </td>
            <td>
              <span>{{ customer?.manager }}</span>
            </td>
            <td>
              <span>{{ customer?.location }}</span>
            </td>
            <td>
              <span>{{ customer.registrationDate | date : dateFormat }}</span>
            </td>
            <td>
              <span
                [ngStyle]="{
                  color: getColorByStatus(customer.statusId, !isForBorder)
                }"
                >{{ customer.statusName }}</span
              >
            </td>
            <td>
              <div class="sign-in-or-edit">
                <span
                  *ngIf="
                    customer.statusId !== CustomerStatusEnum.Deleted &&
                    customer.statusId !== CustomerStatusEnum.Archived &&
                    customer.isInitialModerationPassed
                  "
                  ><a [routerLink]="['/customers/edit', customer?.customerId]"
                    ><svg-icon
                      [svgStyle]="{ 'width.px': '22.25', 'height.px': '20' }"
                      src="assets/img/sign_edit.svg"
                    ></svg-icon
                    >{{ 'label.Edit' | translate }}
                  </a>
                </span>
                <span
                  *ngIf="customer.statusId === CustomerStatusEnum.Active"
                  class="customer-sign-in"
                >
                  <span (click)="onLoginAsCustomer(customer.customerId)" class="customer-login">
                    <svg-icon
                      [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"
                      src="assets/img/login_as_admin.svg"
                    ></svg-icon>
                    {{ 'label.Login' | translate }}
                  </span>
                </span>
              </div>
            </td>
            <td>
              <a
                *ngIf="customer.hasPendingChanges"
                class="moderation-button"
                [routerLink]="['/customers/moderation/', customer.customerId]"
                target="_blank"
              >
                {{ 'label.Moderate' | translate }}
              </a>
            </td>
            <td>
              <button
                type="button"
                class="delete-button"
                (click)="onCustomerDelete(customer)"
                *ngIf="
                  hasCustomerDeletePermission &&
                  customer.isInitialModerationPassed &&
                  customer.statusId !== CustomerStatusEnum.Deleted &&
                  customer.statusId !== CustomerStatusEnum.Archived
                "
              >
                <svg-icon src="assets/img/delete_customer.svg"></svg-icon>
              </button>
            </td>
          </tr>
        </ng-template>

        <!-- 
          <p-column field="name" title="name" [sortable]="true" styleClass="specialName" header="{{'label.CustomerName' | translate}}">
          <ng-template let-col let-customer="rowData" pTemplate="body">
            <span class="customer-edit-link" title="{{customer[col.field] }}"><a [routerLink]="['/customers/view',customer?.customerId]">{{customer[col.field] }}</a></span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.Portfolio'| translate}}" [style]="{'width':'10%'}">
          <ng-template let-col let-customer="rowData" pTemplate="body">
            <span>{{customer?.portfolio}}</span>
          </ng-template>
        </p-column>
        <p-column header="{{'label.AccountManager'| translate}}" [style]="{'width':'15%'}">
          <ng-template let-col let-customer="rowData" pTemplate="body">
            <span>{{customer?.manager}}</span>
          </ng-template>
        </p-column>
        <p-column [sortable]="true" header="{{'label.Location'| translate}}" [style]="{'width':'120px'}">
          <ng-template let-col let-customer="rowData" pTemplate="body">
            <span>{{customer?.locality?.name}}</span>
          </ng-template>
        </p-column>
        <p-column field="registrationDate" [sortable]="true" header="{{'label.RegistrationDate'| translate}}" [style]="{'width':'100px'}">
          <ng-template let-col let-customer="rowData" pTemplate="body">
            <span>{{customer[col.field] | date:dateFormat}}</span>
          </ng-template>
        </p-column>
        <p-column field="statusName" [sortable]="true" header="{{'label.Status'| translate }}" [style]="{'width':'105px'}">
        </p-column>
        <p-column [style]="{width:'10%'}">
           <ng-template let-col let-customer="rowData" pTemplate="body">
              <span *ngIf="customer.statusId != CustomerStatusEnum.Deleted && customer.statusId != CustomerStatusEnum.Archived" class="customer-edit-link"><a [routerLink]="['/customers/edit',customer?.customerId]">{{"label.Edit" | translate }}</a></span>
              <span *ngIf="customer.statusId == CustomerStatusEnum.Active" class="customer-edit-link">| <a href="{{'/login-to/customer-agent-'+ customer?.customerId}}" target="_blank">{{'label.Login' | translate}}</a></span>
           </ng-template>
        </p-column>
        <p-column [style]="{'width':'35px'}">
            <ng-template let-col let-customer="rowData" pTemplate="body">
            <p-button type="button" (click)="onCustomerDelete(customer)" icon="fa fa-times-circle" *ngIf="hasCustomerDeletePermission"></p-button>
        </ng-template>
        </p-column> -->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="8">
              {{ 'message.NoRecordsFound' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
